import { LineToProps } from './LineTo.types'
import dynamic from 'next/dynamic'

export default dynamic<LineToProps>(() => {
    return import('./LineToInternal')
}, { ssr: false })